import Text from '@components/common/text';

import Tooltip from '@components/common/tooltip';
import Icon from '@components/common/assets';
import InputField from '@components/common/hookFormFields/inputField';
import DateField from '@components/common/hookFormFields/dateField';
import JobGroupField from '@components/common/hookFormFields/jobField/jobGroupField';
import JobTitleField from '@components/common/hookFormFields/jobField/jobTitleField';
import PassUpload from './passUpload';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const BasicInfo = () => {
  return (
    <div className={cx('basicInfo')}>
      <div className={cx('form')}>
        <div className={cx('formItem')}>
          <Text fontStyle={FontStyle.B2P_B}>제목</Text>
          <InputField
            prefixName="title"
            height={48}
            placeholder="제목을 입력해 주세요."
            maxLength={100}
            rules={{
              validate: (value) => {
                if (!value) return '제목을 입력해 주세요.';
              },
            }}
          />
        </div>

        <div className={cx('formItem')}>
          <Text fontStyle={FontStyle.B2P_B}>합격 기업/일자</Text>
          <div className={cx('row')} style={{ gap: 24 }}>
            <InputField
              prefixName="companyName"
              width={384}
              height={48}
              placeholder="기업명을 입력해 주세요."
              maxLength={100}
              rules={{
                validate: (value) => {
                  if (!value) return '기업명을 입력해 주세요.';
                },
              }}
            />
            <div style={{ width: '100%' }}>
              <DateField
                prefixName="passDate"
                rules={{
                  validate: (value) => {
                    if (!value) return '합격 일자를 입력해 주세요.';
                  },
                }}
              />
            </div>
          </div>
        </div>

        <div className={cx('formItem')}>
          <Text fontStyle={FontStyle.B2P_B}>합격 직군/직무</Text>
          <div className={cx('row')} style={{ gap: 24 }}>
            <div style={{ width: '384px' }}>
              <JobGroupField
                prefixName={'jobGroup'}
                rules={{
                  validate: (value) => {
                    if (!value) return false;
                  },
                }}
              />
            </div>
            <div style={{ width: '384px' }}>
              <JobTitleField
                prefixName={'jobTitle'}
                jobGroupName={'jobGroup'}
                rules={{
                  validate: (value) => {
                    if (!value) return false;
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={cx('upload')}>
        <div className={cx('title')}>
          <Text fontStyle={FontStyle.B2P_B}>합격 인증 사진 업로드</Text>
          <Tooltip
            tooltipClassName={cx('badge')}
            label={<Icon name="informationLight" width={24} height={24} fill={Colors.C_COOL_GRAY_60} />}
            content={`관리자 확인용이며, 다른 사람에게는 노출되지 않습니다.`}
            placement="top-center"
            theme="gray"
          />
        </div>

        <PassUpload
          prefixName="certificationImageUid"
          rules={{
            validate: (value) => {
              if (!value.length) return false;
            },
          }}
        />
      </div>
    </div>
  );
};

export default BasicInfo;
